import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'src/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { PageHeader } from 'src/components/common/PageHeader';
import { PageContainer } from 'src/components/common/PageContainer';
import { useTestGroup } from 'src/services/api/queries/testQueries';
import { TestGroupPreviewDisplay } from './TestGroupPreviewDisplay';

const TestGroupPreview = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: groupResponse, isLoading: initialLoading } = useTestGroup(id);
  const groupData = groupResponse?.data || null;

  const handleBack = () => {
    navigate('/tests', { state: { activeTab: 'groups' } });
  };

  return (
    <div>
      <PageHeader
        title="Test Group Preview"
        actions={
          <Button
            variant="outline"
            size="headerSm"
            className="gap-1.5"
            onClick={handleBack}
          >
            <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.8} /> Back to
            Tests Management
          </Button>
        }
      />

      <PageContainer className="pb-0 space-y-4">
        {initialLoading ? (
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-primary mx-auto" />
              <p className="mt-4 text-muted-foreground">Loading...</p>
            </div>
          </div>
        ) : (
          <TestGroupPreviewDisplay groupData={groupData} />
        )}
      </PageContainer>
    </div>
  );
};

export default TestGroupPreview;
